import { render, staticRenderFns } from "./PermissionsDetails.vue?vue&type=template&id=0bb2d211&"
import script from "./PermissionsDetails.vue?vue&type=script&lang=js&"
export * from "./PermissionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports